import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-project-alias-redirect',
  template: ''
})
export class ProjectAliasRedirectComponent implements OnInit {
  private readonly internalGarageAlias = '__garage__';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {
  }

  ngOnInit(): void {
    const projectId = this.route.snapshot.paramMap.get('id');
    if (!projectId) {
      void this.router.navigate(['/404']);
      return;
    }

    void this.router.navigate(
      ['/', this.internalGarageAlias, 'garage', projectId],
      {
        queryParams: this.route.snapshot.queryParams,
        skipLocationChange: true,
        replaceUrl: false,
      }
    );
  }
}
